import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWand24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconWand24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m15.549 6.317 2.375-2.376 2.122 2.122-2.376 2.375zm-1.06 1.06L3.96 17.906l2.121 2.121L16.61 9.499zM2.9 18.966a1.5 1.5 0 0 1 0-2.121L16.864 2.881a1.5 1.5 0 0 1 2.121 0l2.121 2.121a1.5 1.5 0 0 1 0 2.121L7.143 21.087a1.5 1.5 0 0 1-2.121 0zm16.593-7.828a.75.75 0 0 1 .75.75v.895h.895a.75.75 0 0 1 0 1.5h-.895v.894a.75.75 0 0 1-1.5 0v-.894h-.895a.75.75 0 0 1 0-1.5h.895v-.895a.75.75 0 0 1 .75-.75m-3.955 4.596a.75.75 0 0 1 .75.75v.348h.346a.75.75 0 0 1 0 1.5h-.346v.345a.75.75 0 0 1-1.5 0v-.345h-.346a.75.75 0 0 1 0-1.5h.346v-.348a.75.75 0 0 1 .75-.75M5.725 3.599a.75.75 0 0 1 1.5 0c0 1.197.97 2.167 2.166 2.167a.75.75 0 0 1 .75.745v.005a.75.75 0 0 1-.75.75c-1.196 0-2.166.97-2.166 2.166a.75.75 0 0 1-.746.75h-.004a.75.75 0 0 1-.75-.75c0-1.196-.97-2.165-2.166-2.166h-.001a.75.75 0 0 1 0-1.5h.001a2.167 2.167 0 0 0 2.166-2.167m.75 2.222q.3.394.694.695-.394.301-.694.694a3.7 3.7 0 0 0-.695-.694q.393-.301.695-.695"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWand24);
